import './header.scss'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { PRICING, VERIFY, LANDING, SUBSCRIBE } from '../../constants/Routes'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBahai } from '@fortawesome/free-solid-svg-icons'
import { faVideo } from '@fortawesome/free-solid-svg-icons'
import { faPhotoVideo } from '@fortawesome/free-solid-svg-icons'
import { faCameraRetro } from '@fortawesome/free-solid-svg-icons'
import { faBlog } from '@fortawesome/free-solid-svg-icons'
import MenuToggler from './../../assets/images/landing-page/menu_toggler.png'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
import LogoText from './../../assets/images/TikBoxLogoBlue.png'
import { useSelector } from 'react-redux'
import RefreshableLink from '../refreshable-link/RefreshableLink'
import { bookEnterpriseMeeting } from '../../utils/Helper'

const PlatformMegaMenu = () => {
  return (
    <div className="mega-menu lv-1">
      <div className="content">
        <div className="primary">
          <div className="sect">
            <ul>
              <li>
                <div className="icon-container">
                  <div className="icon-frame">
                    <FontAwesomeIcon icon={faBahai} />
                  </div>
                </div>
                <div className="text-container">
                  <h3>Copyrights and Licensing</h3>
                  <p>
                    Create licensing agreements and metatags easily with speed
                  </p>
                </div>
              </li>
              <li>
                <div className="icon-container">
                  <div className="icon-frame">
                    <FontAwesomeIcon icon={faVideo} />
                  </div>
                </div>
                <div className="text-container">
                  <h3>Contract Generator</h3>
                  <p>Build custom contracts or use a template</p>
                </div>
              </li>
              <li>
                <div className="icon-container">
                  <div className="icon-frame">
                    <FontAwesomeIcon icon={faPhotoVideo} />
                  </div>
                </div>
                <div className="text-container">
                  <h3>Provenance and Deepfakes</h3>
                  <p>Use C2PA labels to distinguish between real and fake</p>
                </div>
              </li>
              <li>
                <div className="icon-container">
                  <div className="icon-frame">
                    <FontAwesomeIcon icon={faCameraRetro} />
                  </div>
                </div>
                <div className="text-container">
                  <h3>Monetising Copyrights</h3>
                  <p>Auto-invoice licensees and collect payment</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="secondary">
          <div className="sect">
            <h3>Copyrights and Licensing</h3>
            <ul>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
            </ul>
          </div>
          <div className="sect">
            <h3>Contract Generator</h3>
            <ul>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
            </ul>
          </div>
          <div className="sect">
            <h3>Provenance and Deepfakes</h3>
            <ul>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
            </ul>
          </div>
          <div className="sect">
            <h3>Monatizing Copyrights</h3>
            <ul>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

const SolutionsMegaMenu = () => {
  return (
    <div className="mega-menu lv-1">
      <div className="content">
        <div className="primary">
          <div className="sect">
            <ul>
              <li>
                <div className="icon-container">
                  <div className="icon-frame">
                    <FontAwesomeIcon icon={faBahai} />
                  </div>
                </div>
                <div className="text-container">
                  <h3>Copyrights and Licensing</h3>
                  <p>
                    Create licensing agreements and metatags easily with speed
                  </p>
                </div>
              </li>
              <li>
                <div className="icon-container">
                  <div className="icon-frame">
                    <FontAwesomeIcon icon={faVideo} />
                  </div>
                </div>
                <div className="text-container">
                  <h3>Contract Generator</h3>
                  <p>Build custom contracts or use a template</p>
                </div>
              </li>
              <li>
                <div className="icon-container">
                  <div className="icon-frame">
                    <FontAwesomeIcon icon={faPhotoVideo} />
                  </div>
                </div>
                <div className="text-container">
                  <h3>Provenance and Deepfakes</h3>
                  <p>Use C2PA labels to distinguish between real and fake</p>
                </div>
              </li>
              <li>
                <div className="icon-container">
                  <div className="icon-frame">
                    <FontAwesomeIcon icon={faCameraRetro} />
                  </div>
                </div>
                <div className="text-container">
                  <h3>Monetising Copyrights</h3>
                  <p>Auto-invoice licensees and collect payment</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="secondary">
          <div className="sect">
            <h3>Copyrights and Licensing</h3>
            <ul>
              <li>
                <RefreshableLink to={VERIFY} href="#" rel="noreferrer">
                  Check Rights & Provenance
                </RefreshableLink>
              </li>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
            </ul>
          </div>
          <div className="sect">
            <h3>Contract Generator</h3>
            <ul>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
            </ul>
          </div>
          <div className="sect">
            <h3>Provenance and Deepfakes</h3>
            <ul>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
            </ul>
          </div>
          <div className="sect">
            <h3>Monatizing Copyrights</h3>
            <ul>
              <li>
                <a href="#"></a>
              </li>
              <li>
                <a href="#"></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

const ResourcesMegaMenu = () => {
  return (
    <div className="mega-menu lv-3">
      <div className="content">
        <div className="primary">
          <div className="sect">
            <ul>
              <li>
                <div className="icon-container">
                  <div className="icon-frame">
                    <FontAwesomeIcon icon={faBlog} />
                  </div>
                </div>
                <div className="text-container">
                  <h3>
                    <a
                      href="#/"
                      //target="_blank"
                      rel="noreferrer">
                      Blog
                    </a>
                  </h3>
                  <p>Your guide for creative licensing</p>
                </div>
              </li>
              <li>
                <div className="icon-container">
                  <div className="icon-frame">
                    <FontAwesomeIcon icon={faVideo} />
                  </div>
                </div>
                <div className="text-container">
                  <h3>
                    <a
                      href="https://www.youtube.com/tikbox"
                      target="_blank"
                      rel="noreferrer">
                      Video tutorials
                    </a>
                  </h3>
                  <p>How-to video tutorials</p>
                </div>
              </li>
              <li>
                <div className="icon-container">
                  <div className="icon-frame">
                    <FontAwesomeIcon icon={faBahai} />
                  </div>
                </div>
                <div className="text-container">
                  <h3>
                    <a href="#" target="_blank" rel="noreferrer">
                      Trends
                    </a>
                  </h3>
                  <p>Latest in asset licensing</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
const Header = ({ setIsSignUpOpen, setIsSignInOpen }) => {
  const [openMenu, setOpenMenu] = useState(false)
  const { auth } = useSelector((state) => state)

  const toggleMenu = () => {
    setOpenMenu((prevState) => !prevState)
  }
  return (
    <header>
      <div className="tikbox-promo">
        {/*<p>USE THE CODE AHDN30 TO GET $100 OFF</p>*/}
      </div>
      <div className="tikbox-navbar">
        <div className="tikbox-navbar__logo">
          <Link to={LANDING} className="tikbox-logo-link" rel="landing">
            <img src={LogoText} className="tikbox-logo" alt="logo" />
          </Link>
        </div>
        <div className="tikbox-navbar__toggler" onClick={toggleMenu}>
          <img src={MenuToggler} alt="menu-toggler" />
        </div>
        <div className={`tikbox-navbar__menu${openMenu ? ' open' : ''}`}>
          <ul className="tikbox-navbar__menu-links">
            <li className="tikbox-navbar__menu-links__link anchor-link has-mega-menu active">
              <a className="title" href="#">
                <span>Platform</span>
                <FontAwesomeIcon
                  className="dropdown-icon"
                  size="lg"
                  icon={faCaretDown}
                />
              </a>
              <PlatformMegaMenu />
            </li>
            <li className="tikbox-navbar__menu-links__link anchor-link has-mega-menu">
              <a className="title" href="#">
                <span>Solutions</span>
                <FontAwesomeIcon
                  className="dropdown-icon"
                  size="lg"
                  icon={faCaretDown}
                />
              </a>
              <SolutionsMegaMenu />
            </li>
            {/* <li className="tikbox-navbar__menu-links__link anchor-link has-mega-menu mega-menu-relative">
              <a className="title" href="#">
                <span>Resources</span>
                <FontAwesomeIcon
                  className="dropdown-icon"
                  size="lg"
                  icon={faCaretDown}
                />
              </a>
              <ResourcesMegaMenu />
            </li> */}
            {/* <li className="tikbox-navbar__menu-links__link anchor-link">
              <RefreshableLink
                to={VERIFY}
                href="#"
                className="title"
                rel="noreferrer">
                Check Rights & Provenance
              </RefreshableLink>
            </li> */}
            <li className="tikbox-navbar__menu-links__link anchor-link">
              <Link
                to={auth?.isAuthenticated ? SUBSCRIBE : PRICING}
                href="#"
                className="title"
                rel="noreferrer">
                {auth?.isAuthenticated ? 'Subscribe' : 'Pricing'}
              </Link>
            </li>
            <li className="tikbox-navbar__menu-links__link link-btn signin-btn">
              <button onClick={() => setIsSignInOpen(true)}>Sign in</button>
            </li>
            <li className="tikbox-navbar__menu-links__link link-btn book-review-btn">
              <button onClick={bookEnterpriseMeeting}>
                Book Readiness Review
              </button>
            </li>
            <li className="tikbox-navbar__menu-links__link link-btn try-btn">
              <button onClick={() => setIsSignUpOpen(true)}>
                START for FREE
              </button>
            </li>
          </ul>
        </div>
      </div>
    </header>
  )
}

export default Header
